/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
// You need a specific loader for CSS files
Vue.component('multiselect', Multiselect)
export default {
  name: 'update-meeting-details',
  components: {
    datetime: Datetime,
    Multiselect
  },
  props: [
    'meetingID'
  ],
  data () {
    return {
      createMeetingPopup:false,
      userProfileDetails:{},
      meetingListDetails:[],
      start_time:'',
      end_time:'',
      topic:'',
      users:[],
      userList:{},
      userListResults:[], 
      options:[],
      submitted:false,
      sentUserData:[],
      minDatetime:new Date().toISOString()
    }
  },
  computed: {
    ...mapGetters([
      'isConditionalListOfAllUsersGetters',
    ]),
    getUserList() {
      this.userList = this.$store.getters.isConditionalListOfAllUsersGetters.data
      return this.userList
    },
    setIntialsState(){
      if(this.userList != undefined){
        this.userListResults = this.userList
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    }

  },
  mounted () {
    this.getUserList
    this.setIntialsState
    this.$store.dispatch('getMeetingDetailsByIdFun', {id:this.meetingID}).then((res)=>{
      this.start_time = res.data.data.start_time
      this.end_time = res.data.data.end_time
      this.topic = res.data.data.topic
      for(var i = 0; i < res.data.data.users.length; i++){
        this.users.push({first_name:res.data.data.users[i].user.first_name,last_name:res.data.data.users[i].user.last_name,email:res.data.data.users[i].user.email, id : res.data.data.users[i].user.id})
      }
    })
  },
  methods: {
    updateEndTime() {
      if(this.start_time){
        const originalDate = this.start_time;
        const date = new Date(originalDate);
        date.setHours(date.getHours() + 1);
        const newDate = date.toISOString();
        this.end_time = newDate;
      }
    },
    getMeetingListAgain(){
      this.$store.dispatch('getMeetingAllListFun').then((res)=>{
      })
    },
    updateMeetingBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          let data = {
            topic:this.topic,
            start_time:this.start_time,
            end_time:this.end_time,
            users:this.sentUserData,
          }
          this.$store.dispatch('updateMeetingDetailsFun', 
          {
            data: {
              data: data,
              id: this.meetingID
            }
          })
            .then((res) => {  
              toast.success(res.data.msg);
              this.submitted =  false
              this.getMeetingListAgain()
              this.closeUpdateMeetingPopup()
            }).catch((err) => {
              toast.error(err.data.data.email || err.data.user_msg || err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    closeUpdateMeetingPopup(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('updateMeetingStateBus', false);
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.users.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
  },
  watch: {
    getUserList() {
      return this.$store.getters.isConditionalListOfAllUsersGetters.data
    },
    userList(old_val, new_val){
      if(new_val == undefined){
          this.userListResults = old_val
          for(var i = 0; i < this.userListResults.length; i++){
            this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
          }
      }
    },
  },
}